import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Icon } from "antd";

import Tag from "./tag";
import Streets from "./streets";
import { controlModal } from "../../../store/actions/voting.actions";
import useRootEntity from "../../../hooks/useRootEntity";
import useAllowChanges from "../../../hooks/useAllowChanges";

const Regions = ({ companyObj, setFieldsValue }) => {
	const dispatch = useDispatch();
	const [showRegionStreets, setShowRegionStreets] = useState(
		companyObj.regions[0].regionId
	);
	const showRegion = useMemo(
		() =>
			companyObj?.regions.find((regionObj) => {
				return regionObj.regionId === showRegionStreets;
			}),
		[companyObj, showRegionStreets]
	);
	const rootEntity = useRootEntity(
		companyObj.companyId,
		"regions",
		companyObj.companyId
	);
	const changeable = useAllowChanges();
	return (
		<>
			<div className="regions tags-row">
				{companyObj.regions.map((regionObj) => {
					return (
						<Tag
							key={regionObj.regionId || "withoutRegion"}
							tagType={"tag-tab"}
							active={showRegionStreets === regionObj.regionId}
							onClick={() => {
								setShowRegionStreets(regionObj.regionId);
							}}
						>
							{regionObj.region}
						</Tag>
					);
				})}
				{changeable && (
					<Tag
						tagType={"tag-edit tag-margin"}
						onClick={() => {
							dispatch(controlModal(true, "regions", rootEntity));
						}}
					>
						<Icon type="edit" />
					</Tag>
				)}
			</div>
			<Streets
				showStreets={showRegion?.streets}
				setFieldsValue={setFieldsValue}
				companyId={companyObj?.companyId}
			/>
		</>
	);
};

export default Regions;
